var cpFileInput = cpFileInput || {};
(function (obj) {
    obj.init = function () {
        var fileField = jQuery('.js-cp-fileField');
        if (fileField && fileField.length) {
            var fieldIconClass = 'js-fileFieldIcon';
            var fieldInputClass = 'js-fileFieldInput';
            var fieldTextClass = 'js-fileFieldText';
            var fieldRemoveClass = 'js-cpFileFieldRemove';
            var activeClass = 'active';
            fileField.each(function () {
                var initialLabelText = jQuery(this).find('.' + fieldTextClass).text();

                jQuery(this).find('.' + fieldInputClass).on('change', function () {
                    var el = jQuery(this);
                    var fullPath = el.val();
                    var filename = '';
                    if (fullPath) {
                        filename = fullPath.split('\\').pop();
                        el.parent().find('.' + fieldIconClass).addClass(activeClass);
                        el.parent().find('.' + fieldTextClass).text(filename);
                        el.parent().find('.' + fieldRemoveClass).addClass(activeClass);
                    } else {
                        el.parent().find('.' + fieldIconClass).removeClass(activeClass);
                        el.parent().find('.' + fieldTextClass).text(initialLabelText);
                        el.parent().find('.' + fieldRemoveClass).removeClass(activeClass);
                    }

                });

                jQuery(this).find('.' + fieldRemoveClass).on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var el = jQuery(this);
                    el.removeClass(activeClass);
                    el.parent().find('.' + fieldInputClass).val('');
                    el.parent().find('.' + fieldTextClass).text(initialLabelText);
                });

            });
        }
    }
})(cpFileInput);